import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { GetShipmentManifestResponse } from '../../core/api/lab.types';

export const getShipmentManifestThunk = createAsyncThunk(
  'shipment/getShipmentManifest',
  async (shipmentId: string, { rejectWithValue }: any) => {
    const response: GetShipmentManifestResponse = await labApi.getShipmentManifest(shipmentId);

    if (response.data?.getShipmentManifest) {
      return response.data.getShipmentManifest;
    }

    return rejectWithValue(response.errors);
  },
);
